"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.provideContext = exports.default = exports.Provider = exports.Consumer = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = require("react");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const RenderContext = /*#__PURE__*/(0, _react.createContext)({});
var _default = exports.default = RenderContext;
const provideContext = WrappedComponent => {
  const ComponentName = WrappedComponent.displayName || WrappedComponent.name || 'WrappedComponent';
  class WithContext extends _react.PureComponent {
    constructor(props) {
      super(props);
    }
    render() {
      return /*#__PURE__*/React.createElement(RenderContext.Consumer, null, context => {
        const props = {};
        if (this.props.includeState) {
          this.props.includeState.map(({
            path,
            propKey
          }) => {
            if (path === 'breakpoint') {
              props.breakpoint = this.props.breakpoint;
            } else if (propKey) {
              props[propKey] = context.store.getStateValue(path);
            } else {
              Object.assign(props, context.store.getStateValue(path));
            }
          });
        }
        WrappedComponent.contextType = RenderContext;
        return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, this.props));
      });
    }
  }
  WithContext.propTypes = {
    includeState: _propTypes.default.array,
    breakpoint: _propTypes.default.string
  };
  WithContext.contextType = RenderContext;
  WithContext.displayName = `${ComponentName}Container`;
  return WithContext;
};
exports.provideContext = provideContext;
const Provider = exports.Provider = RenderContext.Provider;
const Consumer = exports.Consumer = RenderContext.Consumer;